export const COST_BEHAVIOR_OPTIONS = [
  { value: 'fixed', label: 'Fijo' },
  { value: 'variable', label: 'Variable' },
  { value: 'not_applicable', label: 'No Aplica' },
];

export const COST_NATURE_OPTIONS = [
  { value: 'ordinary', label: 'Ordinario' },
  { value: 'extraordinary', label: 'Extraordinario' },
];

export const COST_TRACEABILITY_OPTIONS = COST_NATURE_OPTIONS;

export const COST_AREA_OPTIONS = [
  { value: 'work', label: 'Obra' },
  { value: 'administration', label: 'Administración' },
  { value: 'rentals', label: 'Alquileres' },
  { value: 'consortiums', label: 'Consorcios' },
  { value: 'holding', label: 'Holding' },
];

export const CURRENCY_OPTIONS = [
  { value: 'ARS', label: 'ARS' },
  { value: 'USD', label: 'USD' },
];

const optionValueAliases = {
  direct: 'ordinary',
  indirect: 'extraordinary',
};

export const getOptionLabel = (options, value) => {
  const normalizedValue = optionValueAliases[value] || value;
  return options.find((option) => option.value === normalizedValue)?.label || value || '-';
};
